export const NETWORK = {
    defaultPort: 2567,
    roomName: "zone",
    /** How often the client uploads its transform. */
    inputSendRateHz: 20,
    /** Server simulation tick — enemy AI, cooldowns, respawns. */
    simulationTickHz: 20,
    /** How often the server flushes state patches to clients. */
    patchRateMs: 50,
    /**
     * Slack on the server's distance budget. Too tight corrects honest players
     * with jitter, too loose lets speed modification through — tune against
     * observed correction frequency, not a theoretical bound.
     */
    movementToleranceFactor: 1.4,
    /**
     * Distance always allowed on top of the time-based budget, so two updates
     * arriving in the same millisecond do not clamp a legitimate step to zero.
     */
    movementBudgetFloor: 0.25,
    /** Divergence in world units before the local client eases toward the server. */
    correctionThreshold: 1.5,
    /** Fraction of the remaining error the client removes per second. */
    correctionRate: 6,
    /**
     * Divergence past which the client snaps instead of easing. A respawn or a
     * hard correction should not look like the cat sliding across the zone.
     */
    correctionSnapDistance: 6,
    /** How far behind the newest packet remote entities are rendered. */
    interpolationDelayMs: 120,
    playerName: { maxLength: 16 },
    chat: {
        maxLength: 200,
        maxLogEntries: 50,
        rateLimitWindowMs: 5000,
        rateLimitMax: 5,
    },
};
//# sourceMappingURL=network.js.map